import { useMemo, useEffect, useReducer } from 'react';
import { translate } from '@utils/i18n';
import { saveCacheToLocalStorage, loadCacheFromLocalStorage } from '../../../helpers/localStorage';
import { INITIAL_FILTERS, ALL_COLUMNS } from '../constants';
import { actionTypes, reducer } from '../reducer';
import { useSprinklerSamplingQuery } from './useSprinklerSamplingQuery';
const BASE_CACHE_KEY = 'kendo/sprinkler_sampling/index';
const useFilteredSprinklerSampling = ({ buildingId }) => {
    const CACHE_KEY = useMemo(() => (buildingId ? `${BASE_CACHE_KEY}/building-${buildingId}` : BASE_CACHE_KEY), [buildingId]);
    const getInitialState = () => {
        const cache = loadCacheFromLocalStorage(CACHE_KEY);
        return {
            data: [],
            loading: false,
            search: '',
            totalCount: 0,
            page: (cache === null || cache === void 0 ? void 0 : cache.page) || {
                skip: 0,
                take: 25
            },
            sort: (cache === null || cache === void 0 ? void 0 : cache.sort) || [],
            filters: (cache === null || cache === void 0 ? void 0 : cache.filters) || INITIAL_FILTERS,
            columns: (cache === null || cache === void 0 ? void 0 : cache.columns) || ALL_COLUMNS
        };
    };
    const [state, dispatch] = useReducer(reducer, null, getInitialState);
    const { page, sort, filters, search, columns } = state;
    const { data: queryData, isLoading, error } = useSprinklerSamplingQuery({
        buildingId,
        page,
        sort,
        filters,
        search
    });
    useEffect(() => {
        if (queryData) {
            dispatch({ type: actionTypes.DATA_LOADED, data: queryData });
        }
    }, [queryData]);
    useEffect(() => {
        saveCacheToLocalStorage(CACHE_KEY, { page, sort, filters, columns });
    }, [CACHE_KEY, page, sort, filters, columns]);
    const onResetCache = () => {
        // eslint-disable-next-line no-alert
        if (!window.confirm(translate('are_you_sure', { namespace: 'generic' })))
            return;
        localStorage.removeItem(CACHE_KEY);
        window.location.reload();
    };
    return {
        data: state.data,
        totalCount: state.totalCount,
        isLoading,
        error: error || null,
        page,
        sort,
        filters,
        search,
        columns,
        dispatch,
        onResetCache,
        CACHE_KEY
    };
};
export default useFilteredSprinklerSampling;
